import { useRef, useState } from "react";
import "./SetPassword.scss";
import { AuthModal } from "../index";
import { Field, Formik, Form } from "formik";
import {
  Button,
  Input,
  PasswordStrengthChecker,
  PasswordValidation,
} from "shared";
import * as Yup from "yup";
import { useSetSuccessorPassword } from "hooks/successors";
import { VALIDATION_ENUM } from "enums";

interface SetPasswordType {
  makeAccess: () => void;
}

const SetPassword = ({ makeAccess }: SetPasswordType) => {
  const [showValidation, setShowValidation] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const formRef = useRef<any>(null);

  const { mutate } = useSetSuccessorPassword({
    onSuccess: () => {
      makeAccess();
    },
  });

  const validation = () =>
    Yup.object().shape({
      email: Yup.string()
        .email(VALIDATION_ENUM.WRONG_EMAIL)
        .required(VALIDATION_ENUM.REQUIRED)
        .matches(
          /^[a-zA-Z0-9_%+-]+([.][a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          VALIDATION_ENUM.WRONG_EMAIL
        ),
      password: Yup.string()
        .required("Pole wymagane")
        .min(8, "Minimum 8 znaków"),
      confirmPassword: Yup.string()
        .required("Pole wymagane")
        .oneOf([Yup.ref("password")], "Hasła muszą być takie same"),
    });

  const initialValues = {
    email: "",
    password: "",
    confirmPassword: "",
  };

  const onSubmit = (values: typeof initialValues) => {
    const { email, password } = values;
    mutate({ email, password });
  };

  return (
    <AuthModal
      heading={"Utwórz hasło do zakładki “Sukcesja”"}
      paragraph={
        <>
          Ze względu na wrażliwy charakter danych przechowywanych w zakładce
          “Sukcesja”, dostęp do niej{" "}
          <strong>wymaga podania osobnego hasła</strong>. Hasło to będzie
          wymagane każdorazowo przy próbie otwarcia zakładki, a także przy
          usuwaniu danych.
        </>
      }
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onSubmit(values)}
        validationSchema={validation()}
        innerRef={formRef}
      >
        {({ values }) => (
          <Form>
            <Field
              type="text"
              id="email"
              name="email"
              label={"E-mail"}
              as={Input}
            />{" "}
            <Field
              type="password"
              id="password"
              name="password"
              label={"Hasło"}
              as={Input}
              onFocus={() => setShowValidation(true)}
              onBlur={() => isPasswordValid && setShowValidation(false)}
            />
            <PasswordStrengthChecker
              password={values.password}
              isHidden={!showValidation}
            />
            <PasswordValidation
              show={showValidation}
              password={values.password}
              setIsValid={(value: boolean) => setIsPasswordValid(value)}
            />
            <Field
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              label={"Powtórz hasło"}
              as={Input}
            />
            <Button
              className="successor-auth-modal__button"
              label={"Potwierdź hasło"}
              styleType="primary"
              type="submit"
              onClick={() => null}
            />
          </Form>
        )}
      </Formik>
    </AuthModal>
  );
};

export default SetPassword;
